import api from '../../services/api'

export const getSurveys = async ({commit, state}, limit) => {
  let response = await api.surveyService.getSurveys(limit)
  if (response) {
    // set clicked for old listview of homepage
    for (let survey of response) survey.clicked = false
    await commit('SET_SURVEYS', response)
    return response
  }
}

export const getTemplate = async ({state, commit}) => {
  let response = await api.surveyService.getTemplate(state.activeSurvey.template)
  let content = await api.surveyService.getFormTemplateContent(state.activeSurvey.template)
  response.template.content = content.data.content
  await commit('SET_ACTIVE_TEMPLATE', response.template)
  return response.template
}

export const getFormUsers = async ({dispatch, state, getters}) => {
  await dispatch('getFormUsersCount')
  let total = getters.getActiveSurveyTotalUsers

  let promises = []
  for (let i = 0; i < total; i += 10000) {
    promises.push(api.userService.getFormUsers(state.activeSurvey.fid, {offset: i}))
  }

  return (await Promise.all(promises)).flat()
}

export const getPagedFormUsers = async ({dispatch, state, rootState}, {fetchObj, limit}) => {
  let respondents = await api.userService.getFormUsers(state.activeSurvey.fid,
      {
        offset: fetchObj.page * limit - limit,
        limit: limit,
        progress: fetchObj.filter.includes('show-all') ? [] : [`${fetchObj.filter}`]
      })

    const respondentsUhList = respondents.map(r => r.uid)

    for (let i = 0; i < respondentsUhList.length; i += 20) {
      let tempList = respondentsUhList.slice(i, i + 20)
      await api.surveyService.getFormUsersPassword(rootState.survey.activeSurvey.fid, {
        uh: tempList.join(';')
      }).then(res => {
        respondents = respondents.map(r => {
          return {
            ...r,
            password: r.password ? r.password : res.find(u => u.uh === r.uid)?.field.password
          }
        })
      })

    }

  return respondents
}

export const getFormUsersCount = async ({commit, state}) => {
  let count = await api.userService.getUserCount(state.activeSurvey.fid)
  commit('SET_ACTIVE_SURVEY_USER_COUNT', count)
  return count
}

export const createNewSurvey = async ({commit, state}, survey) => {
  const newSurvey = await api.surveyService.postSurvey(survey);
  commit('ADD_SURVEY', newSurvey)
  return newSurvey
}

export const setRespondents = async ({commit, state}, {hash, amount}) => {
  return api.surveyService.updateFields(hash, {frm_nonamed_users_granted: amount}, state.activeSurvey.template)
}

export const getSurveyData = async ({commit, dispatch, state, rootState}) => {
  let dataObject = {
    fields: [],
    data: []
  }
  const vars = await dispatch('parantion/data/getVarsFromTemplate', {templateHash: state.activeSurvey.template}, {root: true})

  let responseFields = await api.surveyService.getFields(vars.variablesNamesArray)
  let users = await dispatch('getFormUsers')
  let usersHashes = []
  for (let user of users) {
    usersHashes.push(user.uid)
  }
  const namesArray = ['sur_serial', 'frm_progress', 'email', 'frm_date'].concat(vars.variablesArray.map(e => e.name))
  let responseRespondents = await api.surveyService.getDataV5(state.activeSurvey.fid, namesArray, usersHashes)

  if (responseFields.length) {
    let fields = []

    fields.push({
      datatype: getDataType(3),
      label: 'ID',
      name: 'sur_serial',
      metaname: 'sur_serial'
    })
    fields.push({
      datatype: getDataType(5),
      label: 'E-mail',
      name: 'email',
      metaname: 'email'
    })
    fields.push({
      datatype: getDataType(1),
      label: 'Invuldatum',
      name: 'frm_date',
      metaname: 'frm_date'
    })
    fields.push({
      datatype: getDataType(6),
      label: 'Voortgang',
      name: 'frm_progress',
      metaname: 'frm_progress',
      options: [
        {name: 'progress_idle', label: 'Niet uitgenodigd', value: 0},
        {name: 'progress_queue', label: 'Wachtrij', value: 1},
        {name: 'progress_invite', label: 'Uitgenodigd', value: 2},
        {name: 'progress_remind', label: 'Herinnerd', value: 3},
        {name: 'progress_busy', label: 'Bezig', value: 4},
        {name: 'progress_done', label: 'Klaar', value: 5},
        {name: 'progress_bounce', label: 'Gebounced', value: 6},
        {name: 'progress_refuse', label: 'Geweigerd', value: 7}
      ]

    })
    let orderedFields = []
    let optionGroupHashes = []

    // Sort fields in the same order of the template
    vars.variablesArray.map(e => e.name).forEach(function (key) {
      let found = false
      responseFields.filter(function (item) {
        if (!found && item.name === key) {
          orderedFields.push(item)
          if (item.vogh) {
            optionGroupHashes.push(item.vogh)
          }
          found = true
          return false
        } else {
          return true
        }
      })
    })
    let optiongroupData = await api.surveyService.getVarOptionGroups(optionGroupHashes)
    orderedFields.forEach(function (field) {
      let fieldRow: any = {}
      fieldRow.datatype = field.datatype
      fieldRow.label = field.label
      fieldRow.name = field.name
      fieldRow.metaName = field.vh
      if (field.datatype === 'varoption') {
        let oGroup = optiongroupData.find(function (group) {
          return group.vogh === field.vogh
        })
        fieldRow.isMultiple = oGroup.multiple
        let options = []
        oGroup.varoption.forEach(function (option) {
          let optionRow: any = {}
          optionRow.label = option.label
          optionRow.value = option.value
          optionRow.name = option.name
          options.push(optionRow)
        })
        fieldRow.options = options
      }
      fields.push(fieldRow)
    })
    dataObject.fields = fields

    dataObject.fields = [...dataObject.fields]

    if (responseRespondents.length) {
      responseRespondents.forEach(function (item) {
        let dataRow: any = {}
        dataRow.uid = item.fromsubject
        dataRow.sur_serial = item.row.sur_serial
        dataRow.frm_date = item.row.frm_date
        dataRow.frm_progress = item.row.frm_progress[0].name
        dataObject.fields.forEach(function (field) {
          if (field.datatype === 'varoption') {
            // if array then it is a multiple
            if (field.isMultiple === 1 && item.row[field.name] !== '' && item.row[field.name] !== undefined) {
              let value = []
              item.row[field.name].forEach(function (element) {
                let option = field.options.filter(options => options.name === element.name)
                value.push(option[0])
              })
              setValue(value)
            } else {
              if (item.row[field.name] !== undefined && item.row[field.name][0] && field.options !== undefined) {
                let option = field.options.find(options => options.name === item.row[field.name][0].name)
                if (typeof option !== 'undefined') {
                  setValue(option.name)
                }
              } else {
                setValue()
              }
            }
          } else {
            let value = item.row[field.name]

            setValue(value)
          }

          function setValue (valueObject?) {
            if (typeof valueObject !== 'undefined' || valueObject !== '') {
              dataRow[field.name] = valueObject
            } else {
              dataRow[field.name] = ' - '
            }
          }
        })
        dataRow.email = item.row.email.from
        dataObject.data.push(dataRow)
      })
    }

    dataObject.fields.forEach(function (field) {
      if (field.name !== 'sur_serial' && field.datatype === 'integer') {
        let minMaxArry = []
        dataObject.data.forEach(function (data) {
          if (data[field.name]) {
            minMaxArry.push(data[field.name])
          }
        })
        // @ts-ignore
        let min = Math.min(minMaxArry)
        // @ts-ignore
        let max = Math.max(minMaxArry)
        if (min === max) {
          min = 1
        }
        field.max = max
        field.min = min
      }
    })

    commit('SET_SURVEY_DATA', dataObject)
    return dataObject
  }
}

export const updateActiveSurvey = async ({dispatch, commit, state}, fields) => {
  await api.surveyService.updateFields(state.activeSurvey.fid, fields, state.activeSurvey.template)
  let updatedSurvey = state.activeSurvey
  for (let field in fields) {
    updatedSurvey[field] = fields[field]
  }
  commit('SET_ACTIVE_SURVEY', updatedSurvey)
}

export const updateMailText = async ({dispatch, rootState}, mailObject) => {
  let fieldObject = {}
  fieldObject['frm_invite_sub'] = mailObject.subject
  fieldObject['frm_invite_mes'] = mailObject.text

  if (rootState.parantion.user.config && rootState.parantion.user.config.sender_email) {
    fieldObject['frm_invite_sender_email'] = rootState.parantion.user.config.sender_email
  }
  return dispatch('updateActiveSurvey', fieldObject)
}

export const updateReminderMailText = async ({dispatch, rootState}, mailObjectPromise) => {
  let mailObject = mailObjectPromise
  let fieldObject = {}
  fieldObject['frm_remind_sub'] = mailObject.subject
  fieldObject['frm_remind_mes'] = mailObject.text

  if (rootState.parantion.user.config && rootState.parantion.user.config.sender_email) {
    fieldObject['frm_remind_sender_email'] = rootState.parantion.user.config.sender_email
  }

  await dispatch('updateActiveSurvey', fieldObject)
}

export const retrieveActiveSurvey = async ({commit}, hash) => {
  const response = await api.surveyService.getSurvey(hash)
  if (response) {
    commit('SET_ACTIVE_SURVEY', response)
  }
}

export const resetSurveyStore = async ({state}) => {
  state.surveys = []
  state.questionItems = []
  state.activeSurvey = {}
  state.surveyData = []
}

export const getReportSettings = async ({state}) => {
  const response = await api.surveyService.getTemplateDetails(state.activeSurvey.template, ['easx_report_settings'])
  if (response.data && response.data.detail !== undefined) {
    state.reportSettings = response.data.detail['easx_report_settings']
    return state.reportSettings
  }
}

export const setReportSettings = async ({state}, {settingsJson, templateName}) => {
  if (templateName) {
    let response = await api.surveyService.setTemplateDetails(state.activeSurvey.template, 'easx_report_settings', settingsJson)
    if (response.data) {
      state.reportSettings = JSON.stringify(settingsJson)
    }
  }
}

export const setSort = ({commit, state}, sort) => {
  commit('SET_SORT', sort)
}

export const deleteSurvey = async ({commit, dispatch}, survey) => {
  await dispatch('parantion/items/deleteCollectionFromStore',{collectionName: survey.vgn}, {root: true})
  return await api.surveyService.deleteSurvey(survey.fid)
}

/***** PRIVATE FUNCTIONS ********/
function getDataType (intType) {
  switch (intType) {
    case 1:
      return 'datetime'
    case 2:
      return 'float'
    case 3:
      return 'integer'
    case 4:
      return 'text'
    case 5:
      return 'varchar'
    case 6:
      return 'varoption'
    case 7:
      return 'calculation'
  }
}
